import lunr from "/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/lunr/lunr.js";
require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/lunr-languages/lunr.stemmer.support.js")(lunr);
require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/lunr-languages/lunr.ru.js")(lunr);
require("/home/runner/work/medzuslovjansky.github.io/medzuslovjansky.github.io/node_modules/lunr-languages/lunr.multi.js")(lunr);
export const removeDefaultStopWordFilter = true;
export const language = ["en","ru"];
export const searchIndexUrl = "search-index{dir}.json?_=b18b8564";
export const searchResultLimits = 8;
export const fuzzyMatchingDistance = 1;